import { Component, OnInit, ViewChild, OnDestroy, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from '@services/shared.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-verify-account-modal',
  templateUrl: './verify-account-modal.component.html',
  styleUrls: ['./verify-account-modal.component.scss']
})
export class VerifyAccountModalComponent implements OnInit, OnDestroy {

  @Input() isVerifyEmail: boolean;

  @ViewChild('showVerifyAccountModal', { static: true }) modal: any;
  private showVerifyAccountSubscription: Subscription = null;

  constructor(private modalService: NgbModal, public sharedService: SharedService) { }

  ngOnInit(): void {
    this.showVerifyAccountSubscription = this.sharedService.showVerifyAccountModal.subscribe(show => {
      if (show) {
        this.openModal();
      } 
      else {
        this.closeModal;
      }
    });
  }

  ngOnDestroy() {

    if (this.showVerifyAccountSubscription) { this.showVerifyAccountSubscription.unsubscribe(); }
  }

  openModal() {
    this.modalService.open(this.modal, {
      backdrop: 'static', keyboard: false,
      size: 'lg', centered: true, windowClass: 'modal-full'
    });
  }

  closeModal() {
    this.modalService.dismissAll();
  }

}
